export const HEADER_CONSTANTS = {
  BANK_IDENTIFICATION: 'x-bawagpsk-bank-identification',
  AUTHORIZATION: 'Authorization',
  LANGUAGE: 'x-bawagpsk-language',
  EMPLOYEE_ENTITY: 'x-bawagpsk-employee-entity',
  EMPLOYEE_NUMBER: 'x-bawagpsk-employee-number',
  USER_ENTITY: 'x-bawagpsk-user-entity',
  USER_ID: 'x-bawagpsk-user-id',
  CUSTOMER_ENTITY: 'x-bawagpsk-customer-entity',
  CUSTOMER_NUMBER: 'x-bawagpsk-customer-number',
  CORRELATION_ID: 'x-bawagpsk-correlation-id',
  APP_VERSION: 'x-bawagpsk-app-version',
  VENDOR_ID: 'x-bawagpsk-vendor-id',
  BUSINESS_CHANNEL: 'x-bawagpsk-business-channel',
  BUSINESS_SUB_CHANNEL: 'x-bawagpsk-business-sub-channel',
  APP_ID: 'x-bawagpsk-app-id',
  PLAUSI_CHECK_SESSION_ID: 'x-bawagpsk-plausi-check-session-id',
};
